import React from "react";
import { SchoolWithExamRegistration } from "../../types/types";

interface SignatureSectionProps {
  registrationData: SchoolWithExamRegistration | null;
}

const SignatureSection: React.FC<SignatureSectionProps> = ({
  registrationData,
}) => {
  return (
    <div className="gceo-signature-section">
      <div className="gceo-signature-left">
        <p>
          Payer
          {registrationData?.exam_registration?.payment_info?.payer_name
            ? `:${registrationData.exam_registration.payment_info.payer_name}`
            : "___________________________"}{" "}
          Date
          {registrationData?.exam_registration?.payment_info?.payment_date
            ? `:${registrationData.exam_registration.payment_info.payment_date}`
            : "_______________________"}
        </p>
        <p>Signature</p>
      </div>
      <div className="gceo-signature-right">
        <p>
          Receiver
          {registrationData?.exam_registration?.payment_info?.receiver_name
            ? `:${registrationData.exam_registration.payment_info.receiver_name}`
            : "_______________________________"}
        </p>
        <p>Name & Signature</p>
      </div>
    </div>
  );
};

export default SignatureSection;
